import React, { useEffect } from "react";
import Dropdown from "components/dropdown";
import { FiAlignJustify } from "react-icons/fi";
import { getLevelName } from "../../utils/levelUtils";
import { IoMdNotificationsOutline } from "react-icons/io";
import { Link, useNavigate } from "react-router-dom";
import avatar from "assets/img/avatars/avatar4.png";
import { useAuth } from "context/AuthContext";

  

const Navbar = (props) => {
  const { onOpenSidenav, brandText } = props;
  const {
    logout,
    notifications,
    unreadNotificationsCount,
    adminKycPendingCount,
    adminBankPendingCount,
    fetchNotifications,
    fetchNotificationCount,
    fetchAdminKycPendingCount,
    fetchAdminBankPendingCount,
    markAllNotificationsRead,
  } = useAuth();
  const navigate = useNavigate(); // ✅ To redirect after logout

  const user = JSON.parse(localStorage.getItem('user') || '{}');
  const isAdmin = user.role === 'admin';
  const kycSubmissionNotifications = notifications.filter((notif) => notif.category === 'kyc_submission');
  const bankSubmissionNotifications = notifications.filter((notif) => notif.category === 'bank_submission');
  const generalNotifications = (isAdmin
    ? notifications.filter((notif) => !['kyc_submission', 'bank_submission'].includes(notif.category))
    : notifications).filter((notif) => !notif.read);
  const showKycApprovalNotification = isAdmin && kycSubmissionNotifications.some((notif) => !notif.read);
  const showBankApprovalNotification = isAdmin && bankSubmissionNotifications.some((notif) => !notif.read);
  const unreadCountDisplay = unreadNotificationsCount;

  useEffect(() => {
    fetchNotificationCount();
    fetchAdminKycPendingCount();
    fetchAdminBankPendingCount();
  }, [fetchNotificationCount, fetchAdminKycPendingCount, fetchAdminBankPendingCount]);

  const handleLogout = () => {
    logout(); // ✅ Clear token + user
    navigate("/auth/sign-in"); // ✅ Redirect to login
  };
  return (
    <nav className="sticky top-4 z-40 flex flex-row flex-wrap items-center justify-between rounded-xl bg-white/10 p-2 backdrop-blur-xl dark:bg-[#0b14374d]">
      <div className="ml-[6px]">
        <div className="h-6 w-[224px] pt-1">
          <a
            className="text-sm font-normal text-navy-700 hover:underline dark:text-white dark:hover:text-white"
            href=" "
          >
            Pages
            <span className="mx-1 text-sm text-navy-700 hover:text-navy-700 dark:text-white">
              {" "}
              /{" "}
            </span>
          </a>
          <Link
            className="text-sm font-normal capitalize text-navy-700 hover:underline dark:text-white dark:hover:text-white"
            to="#"
          >
            {brandText}
          </Link>
        </div>
        <p className="shrink text-[33px] capitalize text-navy-700 dark:text-white">
          <Link
            to="#"
            className="font-bold capitalize hover:text-navy-700 dark:hover:text-white"
          >
            {brandText}
          </Link>
        </p>
      </div>

      <div className="relative mt-[3px] flex h-[61px] w-[355px] flex-grow items-center justify-around gap-2 rounded-full bg-white px-2 py-2 shadow-xl shadow-shadow-500 dark:!bg-navy-800 dark:shadow-none md:w-[365px] md:flex-grow-0 md:gap-1 xl:w-[365px] xl:gap-2" style={{    width: "120px"}}>
        {/* <div className="flex h-full items-center rounded-full bg-lightPrimary text-navy-700 dark:bg-navy-900 dark:text-white xl:w-[225px]">
          <p className="pl-3 pr-2 text-xl">
            <FiSearch className="h-4 w-4 text-gray-400 dark:text-white" />
          </p>
          <input
            type="text"
            placeholder="Search..."
            className="block h-full w-full rounded-full bg-lightPrimary text-sm font-medium text-navy-700 outline-none placeholder:!text-gray-400 dark:bg-navy-900 dark:text-white dark:placeholder:!text-white sm:w-fit"
          />
        </div> */}
        <span
          className="flex cursor-pointer text-xl text-gray-600 dark:text-white xl:hidden"
          onClick={onOpenSidenav}
        >
          <FiAlignJustify className="h-5 w-5" />
        </span>
        {/* start Notification */}
        <Dropdown
          button={
            <button
              type="button"
              className="relative rounded-full p-2 text-gray-600 transition hover:bg-gray-100 dark:text-white dark:hover:bg-navy-700"
            >
              <IoMdNotificationsOutline className="h-5 w-5" />
              {unreadCountDisplay > 0 && (
                <span className="absolute -top-1 -right-1 flex h-4 min-w-[1rem] items-center justify-center rounded-full bg-red-500 px-1 text-[10px] font-bold text-white">
                  {unreadCountDisplay}
                </span>
              )}
            </button>
          }
          animation="origin-[65%_0%] md:origin-top-right transition-all duration-300 ease-in-out"
          children={
            <div className="flex w-[360px] max-h-[480px] flex-col gap-3 overflow-y-auto rounded-[20px] bg-white p-4 shadow-xl shadow-shadow-500 dark:!bg-navy-700 dark:text-white dark:shadow-none sm:w-[460px]">
              <div className="flex items-center justify-between border-b border-gray-100 pb-2 dark:border-white/10">
                <p className="text-base font-bold text-navy-700 dark:text-white">Notifications</p>
                {unreadCountDisplay > 0 && (
                  <button
                    type="button"
                    className="text-sm font-semibold text-brand-500 hover:text-brand-600 dark:text-brand-300 dark:hover:text-brand-200 transition-colors"
                    onClick={async () => {
                      try {
                        await markAllNotificationsRead();
                      } catch (error) {
                        console.warn('[Navbar] Mark all read failed', error?.message || error);
                      }
                    }}
                  >
                    Mark all read
                  </button>
                )}
              </div>
              {showKycApprovalNotification && (
                <div className="rounded-xl border border-yellow-300 bg-yellow-50 p-3 text-sm text-yellow-900 dark:border-yellow-500 dark:bg-yellow-900/20 dark:text-yellow-200">
                  <div className="flex items-center justify-between gap-2">
                    <div>
                      <p className="font-semibold">
                        {adminKycPendingCount > 1 ? `${adminKycPendingCount} KYC submissions` : 'New KYC submission'}
                      </p>
                      <p className="text-xs text-slate-700 dark:text-slate-300">
                        Review KYC verification requests now.
                      </p>
                    </div>
                    <button
                      type="button"
                      className="rounded-full bg-yellow-500 px-3 py-1 text-xs font-semibold text-white hover:bg-yellow-600"
                      onClick={() => navigate('/admin/kyc-verification')}
                    >
                      Go to KYC
                    </button>
                  </div>
                </div>
              )}
              {showBankApprovalNotification && (
                <div className="rounded-xl border border-blue-300 bg-blue-50 p-3 text-sm text-blue-900 dark:border-blue-500 dark:bg-blue-900/20 dark:text-blue-200">
                  <div className="flex items-center justify-between gap-2">
                    <div>
                      <p className="font-semibold">
                        {adminBankPendingCount > 1 ? `${adminBankPendingCount} bank verifications` : 'New bank verification'}
                      </p>
                      <p className="text-xs text-slate-700 dark:text-slate-300">
                        Review bank approval requests now.
                      </p>
                    </div>
                    <button
                      type="button"
                      className="rounded-full bg-blue-500 px-3 py-1 text-xs font-semibold text-white hover:bg-blue-600"
                      onClick={() => navigate('/admin/bank-verification')}
                    >
                      Go to Bank
                    </button>
                  </div>
                </div>
              )}
              {generalNotifications.length === 0 && !showKycApprovalNotification && !showBankApprovalNotification ? (
                <div className="rounded-xl border border-gray-200 bg-lightPrimary p-4 text-sm text-gray-600 dark:border-white/10 dark:bg-navy-800 dark:text-white">
                  No new notifications yet.
                </div>
              ) : (
                generalNotifications.map((notification) => (
                  <div
                    key={notification._id}
                    className={`rounded-xl border p-3 ${notification.read ? 'border-gray-200 bg-white dark:border-white/10 dark:bg-navy-800' : 'border-brand-500 bg-brand-50 dark:bg-brand-900/10'}`}
                  >
                    <p className="text-sm font-semibold text-navy-700 dark:text-white">{notification.title}</p>
                    <p className="mt-1 text-sm text-gray-600 dark:text-gray-300">{notification.message}</p>
                    <p className="mt-2 text-xs text-gray-400 dark:text-gray-400">{new Date(notification.createdAt).toLocaleString()}</p>
                  </div>
                ))
              )}
            </div>
          }
          classNames={"py-2 top-4 -left-[230px] md:-left-[440px] w-max"}
        />
        {/* start Horizon PRO */}
        {/* <Dropdown
          button={
            <p className="cursor-pointer">
              <IoMdInformationCircleOutline className="h-4 w-4 text-gray-600 dark:text-white" />
            </p>
          }
          children={
            <div className="flex w-[350px] flex-col gap-2 rounded-[20px] bg-white p-4 shadow-xl shadow-shadow-500 dark:!bg-navy-700 dark:text-white dark:shadow-none">
              <div
                style={{
                  backgroundImage: `url(${navbarimage})`,
                  backgroundRepeat: "no-repeat",
                  backgroundSize: "cover",
                }}
                className="mb-2 aspect-video w-full rounded-lg"
              />
              <a
                target="blank"
                href="https://horizon-ui.com/pro?ref=live-free-tailwind-react"
                className="px-full linear flex cursor-pointer items-center justify-center rounded-xl bg-brand-500 py-[11px] font-bold text-white transition duration-200 hover:bg-brand-600 hover:text-white active:bg-brand-700 dark:bg-brand-400 dark:hover:bg-brand-300 dark:active:bg-brand-200"
              >
                Buy Horizon UI PRO
              </a>
              <a
                target="blank"
                href="https://horizon-ui.com/docs-tailwind/docs/react/installation?ref=live-free-tailwind-react"
                className="px-full linear flex cursor-pointer items-center justify-center rounded-xl border py-[11px] font-bold text-navy-700 transition duration-200 hover:bg-gray-200 hover:text-navy-700 dark:!border-white/10 dark:text-white dark:hover:bg-white/20 dark:hover:text-white dark:active:bg-white/10"
              >
                See Documentation
              </a>
              <a
                target="blank"
                href="https://horizon-ui.com/?ref=live-free-tailwind-react"
                className="hover:bg-black px-full linear flex cursor-pointer items-center justify-center rounded-xl py-[11px] font-bold text-navy-700 transition duration-200 hover:text-navy-700 dark:text-white dark:hover:text-white"
              >
                Try Horizon Free
              </a>
            </div>
          }
          classNames={"py-2 top-6 -left-[250px] md:-left-[330px] w-max"}
          animation="origin-[75%_0%] md:origin-top-right transition-all duration-300 ease-in-out"
        /> */}
        {/* Profile & Dropdown */}
        <Dropdown
          button={
            <img
              className="h-10 w-10 rounded-full cursor-pointer"
              src={avatar}
              alt="Elon Musk"
            />
          }
          children={
            <div className="flex w-56 flex-col justify-start rounded-[20px] bg-white bg-cover bg-no-repeat shadow-xl shadow-shadow-500 dark:!bg-navy-700 dark:text-white dark:shadow-none">
              <div className="p-4">
                <div className="flex flex-col gap-1">
                  <p className="text-sm font-bold text-navy-700 dark:text-white">
                    👋 Hey, {user.fullName}
                  </p>{" "}
                  {user.role !== "admin" && (
                    <p className="text-xs font-semibold text-gray-500 dark:text-gray-400">
                      {getLevelName(user.level)} (L{user.level || 0})
                    </p>
                  )}
                </div>
              </div>
              <div className="h-px w-full bg-gray-200 dark:bg-white/20 " />

              <div className="flex flex-col p-4">
                <Link
                  to={user.role === "admin" ? "/admin/profile" : "/member/profile"}
                  className="text-sm text-gray-800 dark:text-white hover:dark:text-white"
                >
                  Profile Settings
                </Link>
                <Link
                  to="/auth/change-password"
                  className="mt-3 text-sm text-gray-800 dark:text-white hover:dark:text-white"
                >
                  Change Password
                </Link>
                <button onClick={handleLogout} className="text-left mt-3 text-sm font-medium text-red-500 hover:text-red-500 transition duration-150 ease-out hover:ease-in">Log Out</button>
              </div>
            </div>
          }
          classNames={"py-2 top-8 -left-[180px] w-max"}
        />
      </div>
    </nav>
  );
};

export default Navbar;
